module.exports = __webpack_public_path__ + "img/Wave-Check.60649ff9.svg";